import {Select as SelectBase, SelectOptionItem} from '@logistics-frontend/blocks'
import React, {useCallback} from 'react'
import {useController, useFormContext} from 'react-hook-form'

import {scoped} from '../../utils'
import {SelectProps} from './Select.types'

export function Select<T extends unknown>({
  name,
  helperText,
  options,
  rules,
  defaultValue,
  shouldUnregister,
  onChange: onSelect,
  key,
  ...otherProps
}: SelectProps<T>): React.ReactElement<SelectProps<T>> {
  const {control} = useFormContext()

  const {
    fieldState: {error},
    field: {onBlur, onChange, value},
  } = useController({
    control,
    name,
    rules,
    defaultValue,
    shouldUnregister,
  })

  const handleChange = useCallback(
    (item: SelectOptionItem<T> | null) => {
      onSelect && onSelect(item)
      onChange(item?.value)
      onBlur()
    },
    [onBlur, onChange, onSelect],
  )

  return (
    <SelectBase
      key={key ? String(key) : undefined}
      error={Boolean(error?.message)}
      helperText={error?.message ?? helperText}
      name={name}
      onBlur={onBlur}
      onChange={handleChange}
      options={options}
      value={value}
      {...otherProps}
    />
  )
}

export const ScopedSelect = scoped(Select)
